import { BookOpen } from "lucide-react";

export const ManualLink = ({ slug, name, color, testid, auto = true }) => (
  <a
    href={`/downloads/KolorKlinic-${slug}-Manual.pdf`}
    download
    className={`${auto ? "ml-auto " : ""}px-4 py-2 text-xs font-semibold uppercase border flex items-center gap-2 transition-colors hover:bg-white/10`}
    style={{ borderColor: color, color }}
    data-testid={testid}
  >
    <BookOpen size={14} /> {name} manual · PDF
  </a>
);

export const DownloadsHeader = ({ title = "Downloads", ...p }) => (
  <div className="flex flex-wrap items-center gap-3 mb-3">
    <h3 className="font-display uppercase text-xl">{title}</h3>
    <ManualLink {...p} />
  </div>
);
